import { api } from './client';

export interface SignupInput {
  email: string;
  password: string;
  parentalConsent: true;
  firstName?: string;
  /**
   * Cloudflare Turnstile widget response token (A10). The backend
   * verifies via siteverify if `TURNSTILE_SECRET` is configured; if
   * the secret isn't set, the field is ignored. Always send it when
   * the widget is mounted — costs nothing to be present.
   */
  turnstileToken?: string;
}

export const signup = (input: SignupInput) =>
  api<{ ok: true; message?: string }>('/api/v1/auth/signup', { method: 'POST', body: input });

export const verify = (email: string, code: string) =>
  api<{ ok: true }>('/api/v1/auth/verify', { method: 'POST', body: { email, code } });

export const resendVerification = (email: string) =>
  api<{ ok: true }>('/api/v1/auth/resend-verification', { method: 'POST', body: { email } });

export const forgot = (email: string) =>
  api<{ ok: true }>('/api/v1/auth/forgot', { method: 'POST', body: { email } });

export const forgotConfirm = (email: string, code: string, newPassword: string) =>
  api<{ ok: true }>('/api/v1/auth/forgot-confirm', {
    method: 'POST',
    body: { email, code, newPassword },
  });
